import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useTranslate } from 'react-translate';
import PropTypes from 'prop-types';
import BrandLogoHelper from '../../Helpers/BrandLogoHelper';
import { getCurrentYear } from '../../Helpers/getCurrentYear';
import ImageFallback from './ImageFallback';
import isOttoDomain from '../../Helpers/isOttoDomain';
import companyAddress from '../companyAddress';

// const BBBLogo = `${process.env.PUBLIC_URL}/assets/form-imgs/logos/BBB_Logo.png`;
const McAfeeLogo = `${process.env.PUBLIC_URL}/assets/form-imgs/logos/McAfeeSecure_Logo.jpg`;
const McAfeeLogoWebp = `${process.env.PUBLIC_URL}/assets/form-imgs/logos/McAfeeSecure_Logo.webp`;
const AAALogo = `${process.env.PUBLIC_URL}/assets/form-imgs/logos/AAAInsurance_Logo.png`;
const AmericanFamilyLogo = `${process.env.PUBLIC_URL}/assets/form-imgs/logos/AmericanFamilyInsurance_Logo.png`;
const EsuranceLogo = `${process.env.PUBLIC_URL}/assets/form-imgs/logos/Esurance_logo.png`;
const FarmersLogo = `${process.env.PUBLIC_URL}/assets/form-imgs/logos/FarmersInsurance_logo.png`;
const LibertyMutualLogo = `${process.env.PUBLIC_URL}/assets/form-imgs/logos/LibertyMutual_logo.png`;
const NationwideLogo = `${process.env.PUBLIC_URL}/assets/form-imgs/logos/Nationwide_Logo.png`;
const ProgressiveLogo = `${process.env.PUBLIC_URL}/assets/form-imgs/logos/Progressive_logo.png`;
const AAALogoWebp = `${process.env.PUBLIC_URL}/assets/form-imgs/logos/AAAInsurance_Logo.webp`;
const AmericanFamilyLogoWebp = `${process.env.PUBLIC_URL}/assets/form-imgs/logos/AmericanFamilyInsurance_Logo.webp`;
const EsuranceLogoWebp = `${process.env.PUBLIC_URL}/assets/form-imgs/logos/Esurance_logo.webp`;
const LibertyMutualLogoWebp = `${process.env.PUBLIC_URL}/assets/form-imgs/logos/LibertyMutual_logo.webp`;
const NationwideLogoWebp = `${process.env.PUBLIC_URL}/assets/form-imgs/logos/Nationwide_Logo.webp`;
const ProgressiveLogoWebp = `${process.env.PUBLIC_URL}/assets/form-imgs/logos/Progressive_logo.webp`;

const useStyles = makeStyles(() => ({
  container: {
    color: '#808080',
    fontSize: '13px',
    fontWeight: '600',
    textAlign: 'left',
    lineHeight: '18px',
    padding: '25px 0 50px 0',
    backgroundColor: '#f2f2f2',
    borderTop: 'solid 0px #DDD',
    marginTop: '1rem',
    paddingBottom: '2rem',
    paddingTop: '2rem',
  },
  brandContainer: {
    borderTop: '1px solid #f2f2f2',
    paddingTop: '1em',
    marginTop: '12px',
  },
  img: {
    border: 0,
    width: '150px',
  },
  imgLogo: {
    border: 0,
    width: '100%',
    '@media screen and (min-width: 320px) and (max-width: 767px)': {
      width: '40%',
    },
  },
  logoContainer: {
    display: 'flex',
    '@media screen and (min-width: 320px) and (max-width: 767px)': {
      display: 'block',
      textAlign: 'center',
    },
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 'auto',
    marginLeft: 'auto',
    width: '70%',
  },
  imgContainer: {
    display: 'inline',
    marginLeft: '1em',
    marginRight: '1em',
  },
  logos: {
    textAlign: 'center',
    marginBottom: '1em',
  },
  mcAfeeLogo: {
    maxWidth: '115px',
    border: '1px solid #000',
  },
  disclaimer: {},
  linksContainer: {
    marginBottom: '15px',
    lineHeight: '2em',
  },
  links: {
    textDecoration: 'none',
    color: '#2196F3',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  copyrightContainer: {
    marginTop: '1rem',
  },
}));

const renderLogoImages = (classes) => (
  <div className={classes.logoContainer}>
    <div className={classes.imgContainer}>
      <ImageFallback
        className={classes.imgLogo}
        alt="Nationwide"
        fallback={NationwideLogo}
        src={NationwideLogoWebp}
      />
    </div>
    <div className={classes.imgContainer}>
      <ImageFallback
        className={classes.imgLogo}
        alt="Esurance"
        fallback={EsuranceLogo}
        src={EsuranceLogoWebp}
      />
    </div>
    <div className={classes.imgContainer}>
      <ImageFallback
        className={classes.imgLogo}
        alt="AAA"
        fallback={AAALogo}
        src={AAALogoWebp}
      />
    </div>
    <div className={classes.imgContainer}>
      <ImageFallback
        className={classes.imgLogo}
        alt="Farmers"
        fallback={FarmersLogo}
        src={FarmersLogo}
      />
    </div>
    <div className={classes.imgContainer}>
      <ImageFallback
        className={classes.imgLogo}
        alt="Liberty Mutual"
        fallback={LibertyMutualLogo}
        src={LibertyMutualLogoWebp}
      />
    </div>
    <div className={classes.imgContainer}>
      <ImageFallback
        className={classes.imgLogo}
        alt="Progressive"
        fallback={ProgressiveLogo}
        src={ProgressiveLogoWebp}
      />
    </div>
    <div className={classes.imgContainer}>
      <ImageFallback
        className={classes.imgLogo}
        alt="American Family"
        fallback={AmericanFamilyLogo}
        src={AmericanFamilyLogoWebp}
      />
    </div>
  </div>
);

const renderFooterImgs = (classes) => (
  <div className={classes.logos}>
    {/* <div className={classes.imgContainer}>
    <img className={classes.img} src={BBBLogo} alt="" />
    </div> */}
    <div className={classes.imgContainer}>
      <ImageFallback
        className={classes.mcAfeeLogo}
        alt="McAfee"
        fallback={McAfeeLogo}
        src={McAfeeLogoWebp}
      />
    </div>
  </div>
);

const StoriesLinks = function (classes) {
  const { links } = classes;
  return (<a className={links} href="/news" target="_blank">Auto News</a>);
};

const renderLinks = (classes, brand, showSpanish) => (
  <div className={classes.linksContainer}>
    <Link className={classes.links} to="/">{(showSpanish && 'INICIO') || 'Home'}</Link>
    &nbsp; | &nbsp;
    <Link className={classes.links} to="/about.html" target="_blank">{(showSpanish && 'QUIENES SOMOS') || 'About Us'}</Link>
    { isOttoDomain
    && (
    <>
      {' '}
&nbsp; | &nbsp;
      {StoriesLinks(classes, brand)}
    </>
    )}
    &nbsp; | &nbsp;
    <Link className={classes.links} to="/privacypolicy.html" target="_blank">{(showSpanish && 'POLITICA DE PRIVACIDAD') || 'Privacy Policy'}</Link>
    &nbsp; | &nbsp;
    <Link className={classes.links} to="/privacypolicy.html#CAPrivacyRights" target="_blank">{(showSpanish && 'Derechos de privacidad de CA') || 'CA Privacy Rights'}</Link>
    &nbsp; | &nbsp;
    <Link className={classes.links} to="/terms" target="_blank">{(showSpanish && 'TERMINOS DE SERVICIO') || 'Terms of Service'}</Link>
    &nbsp; | &nbsp;
    <Link className={classes.links} to="/reviews.html" target="_blank">{(showSpanish && 'Opiniones') || 'Reviews'}</Link>
    &nbsp; | &nbsp;
    <Link className={classes.links} to="/faq.html" target="_blank">{(showSpanish && 'Preguntas más frecuentes') || 'FAQ'}</Link>
    &nbsp; | &nbsp;
    <Link className={classes.links} to="/ottoGlossary.html" target="_blank">{(showSpanish && 'Preguntas más frecuentes') || 'Glossary'}</Link>
    &nbsp;
    &nbsp;
    <div className={classes.copyrightContainer}>
      ©Copyright 2015-
      {getCurrentYear()}
      {' '}
      {brand}
      {' '}
&nbsp; | &nbsp;
      { companyAddress }
    </div>
  </div>
);

const renderDisclaimer = (brand, translator, showSpanish) => translator((showSpanish && 'RENUNCIA') || 'DISCLAIMER', { brand });

const Footer = function (props) {
  const { brand, variantObject, companyBrand } = props;
  const classes = useStyles();
  const translator = useTranslate('Footer');
  const getBrand = brand.toLowerCase().indexOf('otto') > -1 ? companyBrand : BrandLogoHelper.GetBrand('Auto-Savings', brand);

  return (
    <>
      <Grid className={classes.brandContainer} container alignItems="center" justify="center">
        <Grid item xs={12} md={12} xl={12}>{renderLogoImages(classes)}</Grid>
      </Grid>
      <Grid className={classes.container} container alignItems="center" justify="center">
        <Grid item xs={11} md={10} xl={7}>{renderFooterImgs(classes)}</Grid>
        <Grid item xs={11} md={10} xl={7}>
          {renderLinks(classes, getBrand, !!variantObject.spanish)}
        </Grid>
        <Grid item xs={11} md={10} xl={7} id="footer-disclaimer">{renderDisclaimer(getBrand, translator, !!variantObject.spanish)}</Grid>
      </Grid>
    </>
  );
};

Footer.propTypes = {
  brand: PropTypes.string,
  variantObject: PropTypes.object,
};

Footer.defaultProps = {
  brand: '',
  variantObject: {},
};

export default Footer;
